export const GET_TICKET = 'GE_TICKET';
export const GET_TICKET_SUCCESS = 'GE_TICKET_SUCCESS';
export const GET_TICKET_ERROR = 'GE_TICKET_ERROR';
export const POST_TICKET = 'POST_TICKET';
export const POST_TICKET_SUCCESS = 'POST_TICKET_SUCCESS';
export const POST_TICKET_ERROR = 'POST_TICKET_ERROR';
export const CURRET_TICKET_SELECTED = 'CURRET_TICKET_SELECTED';
